import { assert, RefSet, RefMap } from 'src/util';

import App from './App';
import Room from './Room';
import Game from './Game';
import Player from './Player';

export type Simulator = {
  players: Player[],
  hiddenRatings: RefMap<Player, number>,
  queuedGames: number,
};

export function handleFrame(
  sim: Simulator,
  store: App.Store,
) {
  if (sim.queuedGames <= 0) {
    return;
  }

  addGame(sim, store);
}

function addGame(
  sim: Simulator,
  store: App.Store,
) {
  const app = store.getState();
  const page = App.CurrentPage(app);
  const room = App.CurrentRoom(app);

  if (page === null || room === null) {
    return;
  }

  const gameSuggestions = Room.SuggestedGames(room, app.calculator);

  if (gameSuggestions === null) {
    return;
  }

  if (RefSet.resolve(room.entities.players, sim.players[0].ref) === null) {
    // TODO: Dispatch many actions in one go
    sim.players.forEach(p => store.dispatchRoom(
      room.ref,
      { type: 'add-player', data: p }
    ));

    return;
  }

  const ratings = Room.Ratings(room, app.calculator);

  if (!ratings) {
    return;
  }

  const playerIds = sim.players.map(p => p.ref.id);

  const suggestion = (gameSuggestions
    .find(s =>
      playerIds.indexOf(s.players[0].id) !== -1 &&
      playerIds.indexOf(s.players[1].id) !== -1
    )
  );

  if (!suggestion) {
    return;
  }

  const [r0, r1] = ([
      suggestion.players[0],
      suggestion.players[1],
    ]
    .map(player => RefMap.get(sim.hiddenRatings, player))
  );

  const currWinChance = (() => {
    if (r0 === null || r1 === null) {
      assert(false);
      return 0.5;
    }

    return App.winChance(r0, r1);
  })();

  const outcome = Math.random() < currWinChance ? 'win' : 'loss';

  if (sim.queuedGames > 0) {
    store.dispatchCurrentRoomPage({
      type: 'set-simulator',
      data: { ...sim,
        queuedGames: Math.min(1, sim.queuedGames - 1),
      },
    });
  }

  store.dispatchRoom(
    room.ref,
    {
      type: 'add-game',
      data: Game({ players: suggestion.players, outcome }),
    }
  );
}



// WEBPACK FOOTER //
// ./src/state/Simulator.ts